import React from 'react';
import './GalaxyStepper.css';

const GalaxyStepper = (props) => {
    return(
        <div className="stepper-container">
            <ul>
                <li className={props.stepper1Class}><span onClick={() => props.loadData(1,props.currentStep)} >1</span> Select Candidates</li>
                <li className={props.stepper2Class}><span onClick={() => props.loadData(2,props.currentStep)} >2</span> Interview Details</li>
                <li className={props.stepper3Class}><span onClick={() => props.loadData(3,props.currentStep)} >3</span> Date and Time</li>
                <li className={props.stepper4Class}><span onClick={() => props.loadData(4,props.currentStep)} >4</span> Confirm Details</li>
            </ul>
        </div>
    );
}

export default GalaxyStepper;


// WEBPACK FOOTER //
// ./src/components/UI/GalaxyStepper/GalaxyStepper.js